module.exports = __webpack_public_path__ + "img/down-sx1.d462cfc0.png";